module.exports = __webpack_public_path__ + "img/1970East-032_WEB-min.eab04981.jpg";